import { NavLink, Outlet } from 'react-router-dom';

import { Icon, type IconName } from '@/components/Icon/Icon';
import { SettingsLayout } from '@/components/SettingsLayout/SettingsLayout';

const SECTIONS: { to: string; label: string; icon: IconName; end?: boolean }[] = [
  { to: '/settings', label: 'Profile', icon: 'user', end: true },
  { to: '/settings/api-keys', label: 'API Keys', icon: 'key' },
];

export function SettingsLayoutContainer() {
  return (
    <SettingsLayout
      nav={SECTIONS.map(({ to, label, icon, end }) => (
        <NavLink key={to} to={to} end={end}>
          {({ isActive }) => (
            <>
              <Icon name={icon} filled={isActive} />
              {label}
            </>
          )}
        </NavLink>
      ))}
    >
      <Outlet />
    </SettingsLayout>
  );
}
